// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"171":"collection","354":"community","644":"account","841":"studio"}[chunkId] || chunkId) + "." + {"171":"aa7a730e","354":"a850b31c","515":"41054292","644":"1fb01687","841":"f1297be1","896":"41054292"}[chunkId] + ".css";
};